import * as React from 'react'
import Grid from '@mui/material/Grid'
import Toolbar from '@mui/material/Toolbar'
import { Breadcrumbs } from '@mui/material'
import { styled } from '@mui/material/styles'
import MenuIcon from '@mui/icons-material/Menu'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import { Link as RouteLink, useRouter } from 'react-location'
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar'

import { LocationGenerics } from '../../types'

import HeaderSearch from '../ui/HeaderSearch'
import { useBrand } from '../../stores/brand-store'

type ComponentProps = {
  handleDrawerOpen: () => void
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<MuiAppBarProps>(({ theme }) => ({
  zIndex: theme.zIndex.drawer - 1,
  backgroundColor: theme.palette.primary.contrastText,
  color: theme.palette.secondary.main,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${theme.spacing(7)})`,
  },
  '& .MuiToolbar-root': {
    height: 70,
  },
}))

function Header(props: ComponentProps): JSX.Element {
  const { handleDrawerOpen } = props

  const router = useRouter<LocationGenerics>()
  const {
    state: { matches },
  } = router

  const { data: brand } = useBrand()

  return (
    <AppBar position="fixed">
      <Toolbar>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item container xs="auto" justifyContent="flex-start" alignItems="center">
            <Grid item>
              <IconButton
                edge="start"
                color="primary"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                sx={{ display: { lg: 'none' } }}
              >
                <MenuIcon />
              </IconButton>
            </Grid>

            <Grid item>
              <RouteLink to="/">
                <Grid item sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', margin: ' 0 25px' }}>
                  <img
                    alt="leadliaison"
                    src={brand?.brandLogo ? brand.brandLogo : '/images/logo-color-leadliaison.png'}
                    style={{ width: 153 }}
                  />
                </Grid>
              </RouteLink>
            </Grid>

            <Grid item>
              <Breadcrumbs aria-label="breadcrumb" sx={{ display: { xs: 'none', md: 'block' } }}>
                {matches
                  .filter((match) => match.route.meta?.breadcrumb)
                  .map((match, _, arr) =>
                    match.route.path !== arr.at(-1)?.route.path ? (
                      <RouteLink key={match.route.path} to={match.pathname}>
                        <Typography sx={{ color: 'primary.main', fontWeight: 700, textTransform: 'capitalize' }}>
                          {match.route.meta?.breadcrumb?.(match) as string}
                        </Typography>
                      </RouteLink>
                    ) : (
                      <Typography
                        key={match.route.id}
                        color="text.primary"
                        sx={{ fontWeight: 700, textTransform: 'capitalize' }}
                      >
                        {match.route.meta?.breadcrumb?.(match) as string}
                      </Typography>
                    )
                  )}
              </Breadcrumbs>
            </Grid>
          </Grid>

          <Grid item container xs justifyContent="flex-end">
            <HeaderSearch />
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  )
}
export default Header
